const store = {
    namespaced: true,
    state: {
        userId: null,
        userName: null,
        email: null,
        firstName: null,
        lastName: null,
        title: null,
        emailSignature: null,
        extension: null,
        phone: null,
        calendlyLink: null,
        internal: false,
        mobilePhone: null,
        mfaMethod: null
    },
    actions: {
        async load({commit, rootState, state}) {
            let userProfileId = rootState.session.user.userId;
            commit('setProfileUserId', userProfileId);
            let userProfile = await romeApi.get(`user/profile/${state.userId}`);
            commit('setUserProfile', userProfile);
            let internal = await romeApi.get(`user/profile/${state.userId}/internalCheck`);
            commit('setInternal', internal);
            if (internal) {
                let emailSignature = await romeApi.get(`/user/profile/${state.userId}/signature`);
                commit('setEmailSignature', emailSignature);
            }
        },
        async update({commit}, userProfile) {
            await romeApi.post(`user/profile/${userProfile.userId}`, userProfile);
            commit('setUserProfile', userProfile);
        },
        async updateEmailSignature({commit}, signature) {
            await romeApi.post(`user/profile/${signature.userId}/signature`, signature);
            commit('setEmailSignature', signature.emailSignature);
        }
    },
    mutations: {
        setProfileUserId(state, userId) {
            state.userId = userId;
        },
        setUserProfile(state, userProfile) {
            utils.copyCommonProperties(userProfile, state);
        },
        setInternal(state, internal) {
            state.internal = internal;
        },
        setEmailSignature(state, emailSignature) {
            state.emailSignature = emailSignature;
        }

    }
};

export default store;



// WEBPACK FOOTER //
// ./src/user/x-user-profile.js